import { ComponentProps, FC } from 'react';
import { GenericInput } from './GenericInput';
import { RegisterOptions } from 'react-hook-form';
import { INPUT_INVALID_FORMAT_MESSAGE } from '../../../constants/form';

const EMAIL_PATTERN: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const InputEmail: FC<ComponentProps<typeof GenericInput>> = (props) => {
  const validationOptions = getValidationOptions();

  return <GenericInput {...props} registerOptions={validationOptions} />;
};

InputEmail.defaultProps = {
  charactersType: 'caracteres',
  maxLength: 254,
};

function getValidationOptions(): RegisterOptions {
  const registerOptions: RegisterOptions = {
    pattern: {
      value: EMAIL_PATTERN,
      message: INPUT_INVALID_FORMAT_MESSAGE,
    },
  };

  return registerOptions;
}
